


// Interfaces




export const notificationData = {
  "Today": [
    {
      id: 1,
      avatar: <img src={""} alt="profile" />,
      notification: "Tommorow You have upcomming shift with Tall Tree on 08:30am",
      date: "08:40 AM - August 2, 2022",
    },
    {
      id: 11,
      avatar: <img src={""} alt="profile" />,
      notification: "Your upcomming shift is cancelled by John Doe",
      date: "08:40 AM - August 2, 2022",
    },
    {
      id: 111,
      avatar: <img src={""} alt="profile" />,
      notification: "John Doe has provided sign off on your completed shift",
      date: "08:40 AM - August 2, 2022",
    },
  ],
  "Yesterday": [
    {
      id: 1,
      avatar: <img src={""} alt="profile" />,
      notification: "Tommorow You have upcomming shift with Tall Tree on 08:30am",
      date: "08:40 AM - August 2, 2022",
    },
    {
      id: 11,
      avatar: <img src={""} alt="profile" />,
      notification: "You have a new Shift Request",
      date: "08:40 AM - August 2, 2022",
    },
    {
      id: 111,
      avatar: <img src={""} alt="profile" />,
      notification: "Your Check-in time is approved by John Doe",
      date: "08:40 AM - August 2, 2022",
    },
    {
      id: 1111,
      avatar: <img src={""} alt="profile" />,
      notification: "Tommorow You have upcomming shift with Tall Tree on 08:30am",
      date: "08:40 AM - August 2, 2022",
    },
  ]

}
